// Cold-start arming for the launch motion (Figma page 07 annotation "Cold app launch only").
// A page load is a cold start: main.tsx arms this once, the overlay consumes it on its first mount,
// and nothing can arm it again — a resumed app, a tab switch or a re-render never replays it.
let armed = false;

// Total time on screen before the overlay removes itself (the motion itself ends at ~1.3s).
export const LAUNCH_MS = 1600;

export function armLaunchAnimation(): void {
  armed = true;
}

export function takeLaunchAnimation(): boolean {
  const play = armed;
  armed = false;
  return play;
}
